export enum PageLayout {
  DEFAULT,
  SIDE,
  NOT_FOUND,
  GAME,
  EMPTY,
  ROOKIE,
  UNKNOWN
}
